module.exports = __webpack_public_path__ + "static/media/quarterly25.279814fe.png";